<script >
import { computed } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  stock: {
    type: Object,
    default: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const metricSections = computed(() => [{
    id: 'levels',
    title: 'Niveles',
    metrics: [{
      label: 'Precio',
      value: props.stock?.priceLabel || 'N/D'
    }, {
      label: 'Entrada',
      value: props.stock?.entryPriceLabel || 'N/D'
    }, {
      label: 'Stop',
      value: props.stock?.stopPriceLabel || 'N/D'
    }, {
      label: 'Soporte',
      value: props.stock?.supportPriceLabel || 'N/D'
    }]
  }, {
    id: 'reading',
    title: 'Lectura Eurekers',
    metrics: [{
      label: 'Rentabilidad',
      value: props.stock?.profitabilityLabel || 'N/D'
    }, {
      label: 'Compatibilidad',
      value: props.stock?.userCompatibilityLabel || 'N/D'
    }, {
      label: 'Entrada tipo',
      value: props.stock?.entryTypeLabel || 'N/D'
    }, {
      label: 'Distancia entrada',
      value: props.stock?.entryDistanceLabel || 'N/D'
    }]
  }, {
    id: 'context',
    title: 'Contexto',
    metrics: [{
      label: 'Sector',
      value: props.stock?.sector || 'N/D'
    }, {
      label: 'Industria',
      value: props.stock?.industry || 'N/D'
    }, {
      label: '1ª fecha',
      value: props.stock?.firstBarDateFormatted || 'N/D'
    }, {
      label: 'Fecha soporte',
      value: props.stock?.supportDateFormatted || 'N/D'
    }]
  }]);
  return {
    metricSections
  };
};
export default __sfc_main;
</script>

<template>
    <div v-if="stock" class="charting-eurekers-analysis">
        <section v-for="section in metricSections" :key="section.id" class="charting-eurekers-analysis__section">
            <div class="charting-eurekers-analysis__section-header">
                <h3>{{ section.title }}</h3>
            </div>
            <div class="charting-eurekers-analysis__grid">
                <div v-for="metric in section.metrics" :key="`${section.id}-${metric.label}`" class="charting-workspace-inspector__summary-cell charting-eurekers-analysis__metric">
                    <div class="charting-workspace-inspector__summary-label">{{ metric.label }}</div>
                    <div class="charting-workspace-inspector__summary-value">{{ metric.value }}</div>
                </div>
            </div>
        </section>
    </div>
    <div v-else class="brand-empty-state rounded-xl border border-dashed p-4 text-sm">Sin ticker seleccionado.</div>
</template>

<style scoped>
.charting-eurekers-analysis {
    display: flex;
    min-height: 0;
    flex-direction: column;
    gap: 1rem;
}

.charting-eurekers-analysis__section {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.charting-eurekers-analysis__section-header {
    display: flex;
    height: 1.75rem;
    align-items: center;
    justify-content: flex-start;
    gap: 0.35rem;
}

.charting-eurekers-analysis__section h3 {
    margin: 0;
    font-size: 0.82rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    line-height: 1.1;
    text-transform: uppercase;
    color: var(--p-text-muted-color);
}

.charting-eurekers-analysis__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
}

.charting-eurekers-analysis__metric {
    min-width: 0;
}

@media (max-width: 640px) {
    .charting-eurekers-analysis__grid {
        grid-template-columns: 1fr;
    }
}
</style>
